import React from 'react';
import { AlertTriangle, Camera, Plus, Wrench } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useTenant } from './TenantContext';

const TenantAnomalies = () => {
  const { myAnomalies, setShowReportModal } = useTenant();
  return (
    <>
  <Card>
    <CardHeader className="flex flex-row items-center justify-between pb-3">
      <CardTitle className="text-lg flex items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-amber-500" />
        Signalement d'Anomalies
      </CardTitle>
      <Button size="sm" onClick={() => setShowReportModal(true)} className="bg-[#1B3A4B] hover:bg-[#142D3A]" data-testid="tenant-report-anomaly-btn">
        <Plus className="w-4 h-4 mr-1" /> Signaler
      </Button>
    </CardHeader>
    <CardContent>
      {myAnomalies.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          <AlertTriangle className="w-10 h-10 mx-auto mb-2 opacity-30" />
          <p className="text-sm">Aucune anomalie signalée</p>
          <p className="text-xs mt-1">Signalez un problème dans votre logement ou les parties communes</p>
        </div>
      ) : (
        <div className="space-y-3">
          {myAnomalies.map(anomaly => (
            <div key={anomaly.id} className="border border-gray-100 rounded-lg p-3" data-testid={`tenant-anomaly-${anomaly.id}`}>
              <div className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${anomaly.priority === 'urgente' ? 'bg-red-100' : anomaly.priority === 'faible' ? 'bg-green-100' : 'bg-amber-100'}`}>
                  <Wrench className={`w-4 h-4 ${anomaly.priority === 'urgente' ? 'text-red-600' : anomaly.priority === 'faible' ? 'text-green-600' : 'text-amber-600'}`} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-medium text-sm capitalize">{anomaly.category?.replace('_', ' ')}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${anomaly.status === 'signale' ? 'bg-red-100 text-red-700' : anomaly.status === 'en_cours' ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700'}`}>
                      {anomaly.status === 'signale' ? 'Signalé' : anomaly.status === 'en_cours' ? 'En cours' : 'Résolu'}
                    </span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${anomaly.priority === 'urgente' ? 'bg-red-50 text-red-600' : anomaly.priority === 'faible' ? 'bg-green-50 text-green-600' : 'bg-amber-50 text-amber-600'}`}>
                      {anomaly.priority === 'urgente' ? 'Urgent' : anomaly.priority === 'faible' ? 'Faible' : 'Normal'}
                    </span>
                    <span className="text-xs text-gray-400">{anomaly.location_type === 'partie_commune' ? 'Partie commune' : 'Chez vous'}</span>
                  </div>
                  <p className="text-sm text-gray-600">{anomaly.description}</p>
                  <p className="text-xs text-gray-400 mt-1">{anomaly.reported_at?.split('T')[0]}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
    </>
  );
};

export default TenantAnomalies;
